import React, { useCallback, useEffect, useRef, useState } from 'react'
import UnassignedPaths from './unassignedPaths'

export const MIN_HEIGHT = 60
export const MAX_HEIGHT = 500

export default function ResizablePanel({ children, position = 'fixed' }) {
  const ref = useRef()
  const isDraggingRef = useRef()
  const [height, setHeight] = useState(200)

  const handleMouseDown = useCallback(() => {
    isDraggingRef.current = true
    const assignSectionEl = document.getElementById('form-builder-assign-section')
    assignSectionEl.style.userSelect = 'none'
  }, [])

  const handleMouseUp = useCallback(() => {
    isDraggingRef.current = false
    const assignSectionEl = document.getElementById('form-builder-assign-section')
    assignSectionEl.style.userSelect = 'auto'
  }, [])

  const handleMouseMove = useCallback((e) => {
    if (!isDraggingRef.current) return
    const newHeight = window.innerHeight - e.clientY - (window.innerHeight - ref.current.getBoundingClientRect().bottom)
    if (newHeight >= MIN_HEIGHT && newHeight <= MAX_HEIGHT) setHeight(newHeight + 12)
  }, [])

  useEffect(() => {
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [])

  return (
    <div
      ref={ref}
      id="form-builder-resizeable-section"
      style={{ height: `${height}px`, width: '100%', position: position, bottom: 0, zIndex: 3 }}
    >
      <div
        style={{
          height: '100%',
          overflow: 'auto',
          background: '#F0F0F0',
          padding: '12px 48px 0px 48px',
          boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.11) inset',
        }}
      >
        <div style={{ height: '100%' }} className="dome-d-flex dome-flex-column dome-gap12">
          <div className="dome-d-flex dome-align-center dome-justify-center">
            <div
              onMouseDown={handleMouseDown}
              style={{ width: 79, height: 4, borderRadius: 100, background: '#B7B7B7', cursor: 'grab' }}
            ></div>
          </div>
          <div style={{ width: '65%', flex: 1, overflow: 'auto', paddingBottom: '36px' }}>
            <UnassignedPaths />
          </div>
        </div>
      </div>
    </div>
  )
}
